/**
 * PublicRecordDetailRoute — which renderer draws /p/:tableSlug/:recordId.
 *
 * The event table is drawn by React components (EventDetailPage); every other
 * table keeps the generic renderer exactly as it was. The override lives here,
 * in one branch on the slug, rather than inside PublicRecordDetailPage — that
 * page serves every application on the platform, and an app-specific detour in
 * the middle of it is the kind of thing nobody finds later.
 *
 * Which slug is overridden is a single constant (EVENT_TABLE_SLUG), so removing
 * the override is removing one line.
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import PublicRecordDetailPage from './PublicRecordDetailPage';
import EventDetailPage, { EVENT_TABLE_SLUG } from './EventDetailPage';

export default function PublicRecordDetailRoute() {
  const { tableSlug } = useParams();

  if (tableSlug === EVENT_TABLE_SLUG) return <EventDetailPage />;

  return <PublicRecordDetailPage />;
}
